import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import ApiService from '@/services/apiService';
import deviceMixin from './deviceMixin';
import get from 'lodash/get';
export default {
  name: 'IsAssetMgmtEdit',
  mixins: [deviceMixin],
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      formValid: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems() {
      return Object.keys(this.operationalStatus).map(status => {
        return {
          text: this.operationalStatus[status],
          value: status
        };
      });
    },
    cardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  },
  methods: {
    get,
    localizeDate,
    setTags(tags) {
      this.twinObject.data.tags = tags;
    },
    saveAsset() {
      // polygon is set server-side and adapted to the current coordinate
      if (this.twinObject.data.polygonMode === 'auto') {
        this.twinObject.polygon = null;
      }
      this.twinObject.data.assetManagement.deviceIds = this.deviceData.map(d => d.deviceId);
      ApiService.digitalTwinUpdate(this, this.twinObject).then(result => {
        this.twinObject = result;
        this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdated'), 'success');
        this.$emit('close', result);
        return this.twinObject;
      }).catch(error => {
        console.error(error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.digitalTwins.twinUpdatedFail'), 'error');
        }
      }).finally(() => {
        this.$store.state.app.loading = false;
      });
    }
  }
};